export function reorderUrl(urlLink) {
    if (!urlLink) return urlLink;

    const hasHash = urlLink.includes('#');
    const hasQuery = urlLink.includes('?');

    let fallbackQuery = '';
    if (typeof window !== 'undefined' && window.location.hash.includes('?')) {
        fallbackQuery = window.location.hash.split('?')[1];
    }

    if (!hasQuery && fallbackQuery) {
        if (hasHash) {
            const [leftOfHash, hashPart] = urlLink.split('#');
            const cleanHash = hashPart.split('?')[0];
            return `${leftOfHash}?${fallbackQuery}#${cleanHash}`;
        }

        return `${urlLink}?${fallbackQuery}`;
    }

    if (!hasHash || !hasQuery) return urlLink;

    const [leftOfHash, hashPart] = urlLink.split('#');
    const [leftOfQuery, queryPart] = leftOfHash.split('?');

    const cleanHash = hashPart.split('?')[0];
    const cleanQuery = hashPart.includes('?')
        ? hashPart.split('?')[1]
        : queryPart;

    return `${leftOfQuery}?${cleanQuery}#${cleanHash}`;
}
